import { User } from '@tassomutuo-backoffice/types';
import { Period } from '../api/statistics/statistics';
import { DateRange } from '../../pages/dashboard/hooks/useStatistics';

const DASHBOARD_FILTERS_SESSION_KEY = 'dashboard_filters';

interface DashboardFilters {
  selectedPeriod?: Period | null;
  groupId?: string | null;
  selectedMember?: Pick<
    User,
    'id' | 'hubspotOwnerId' | 'name' | 'email'
  > | null;
  dateRange?: DateRange | null;
}

export const setDashboardFiltersInSessionStorage = (
  filters: DashboardFilters
) => {
  const existingFilters = getDashboardFiltersInSessionStorage() || {};
  const updatedFilters = { ...existingFilters, ...filters };
  sessionStorage.setItem(
    DASHBOARD_FILTERS_SESSION_KEY,
    JSON.stringify(updatedFilters)
  );
};

export const getDashboardFiltersInSessionStorage =
  (): DashboardFilters | null => {
    const filtersInSessionStorage = sessionStorage.getItem(
      DASHBOARD_FILTERS_SESSION_KEY
    );
    if (filtersInSessionStorage) {
      return JSON.parse(filtersInSessionStorage);
    }
    return null;
  };

export const removeDashboardFiltersInSessionStorage = () => {
  sessionStorage.removeItem(DASHBOARD_FILTERS_SESSION_KEY);
};
